/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FeatureRepresentation
 */
export interface FeatureRepresentation {
    /**
     * 
     * @type {string}
     * @memberof FeatureRepresentation
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof FeatureRepresentation
     */
    name: string;
}

/**
 * Check if a given object implements the FeatureRepresentation interface.
 */
export function instanceOfFeatureRepresentation(value: object): value is FeatureRepresentation {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function FeatureRepresentationFromJSON(json: any): FeatureRepresentation {
    return FeatureRepresentationFromJSONTyped(json, false);
}

export function FeatureRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeatureRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'name': json['name'],
    };
}

export function FeatureRepresentationToJSON(json: any): FeatureRepresentation {
    return FeatureRepresentationToJSONTyped(json, false);
}

export function FeatureRepresentationToJSONTyped(value?: FeatureRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'name': value['name'],
    };
}

